import { render, staticRenderFns } from "./ad-shuttle.vue?vue&type=template&id=d5598a44"
import script from "./ad-shuttle.vue?vue&type=script&lang=js"
export * from "./ad-shuttle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1671620415/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5598a44')) {
      api.createRecord('d5598a44', component.options)
    } else {
      api.reload('d5598a44', component.options)
    }
    module.hot.accept("./ad-shuttle.vue?vue&type=template&id=d5598a44", function () {
      api.rerender('d5598a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-shuttle.vue"
export default component.exports